export class BreakPoints {
  static readonly DESKTOP = "(max-width: 1024px)";
  static readonly PHONE = "(max-width: 420px)";
  static readonly TABLET = "(min-width: 768px) and (max-width: 1024px)";
  static readonly MOBILE = "(max-width: 768px)";
  static readonly DESKTOP_L = "(max-width: 1366px)";
  static readonly TABLET_FORM = "(min-width: 768px) and (max-width: 1366px)";
  static readonly PHONE2 = "(max-width: 476px)";
}
  
